import { graphql } from 'react-relay';

import { commit } from '../../mutations/commit';

const mutation = graphql`
  mutation deleteInvoiceMutation($input: DeleteInvoiceInput!, $storeId: ID!) {
    deleteInvoice(input: $input) {
      destroyedInvoiceId
      storeLists {
        ...InvoiceList_storeLists @arguments(storeId: $storeId)
      }
    }
  }
`;

const deleteInvoice = (environment, params, listsId, args = {}) => {
  const { id, storeId } = params;
  return commit(environment, {
    mutation,
    variables: {
      input: {
        id,
      },
      storeId,
    },
    configs: [
      {
        type: 'RANGE_DELETE',
        parentID: listsId,
        connectionKeys: [{ key: 'InvoiceList_invoices' }],
        pathToConnection: ['storeLists', 'invoices'],
        deletedIDFieldName: 'destroyedInvoiceId',
      },
    ],
    ...args,
  });
};

export default deleteInvoice;
